import { Injectable, inject } from '@angular/core';

import { CheckoutStorageService } from '@bytel/checkout';

import { BasicObject } from '@interfaces/checkout.interface';
import { IInitialConfig } from '@interfaces/config.interface';

import { initialConfig } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ConfigurationService {
    protected storage: CheckoutStorageService = inject(CheckoutStorageService);
    private _storageKey = 'configurations';
    private _initialConfig: IInitialConfig;

    public constructor() {
        this._initialConfig = initialConfig();
    }

    public getData(): IInitialConfig {
        return this._initialConfig;
    }

    // Overwrite feature flags via session for dynamic changes.
    // This allows for the alteration of feature flags at runtime based on session variables.
    // Useful for testing or conditional feature deployment.
    // See feature module in https://gitlab.int.nbyt.fr/A360/the-monkeys-paw.
    public getFeatures(): IInitialConfig['features'] {
        const sessionFeatures = JSON.parse(sessionStorage.getItem('portailvente_features') || '{}');
        const windowFeatures = this.getData().features;

        return { ...windowFeatures, ...sessionFeatures };
    }

    protected saveConfigurations(configurations: BasicObject): void {
        /* Configuration is generated every hour */
        const hourMilliseconds: number = 3600 * 1000;
        const expirationDate: number = new Date().getTime() + hourMilliseconds;
        this.storage.set(this._storageKey, configurations, true, expirationDate);
    }
}
